import * as React from "react";
import Box from "@mui/material/Box";
import { AddCustomAction } from "./AddCustomAction";
import { ICustomAmountDetailsFormState } from "./AmountDetailsField";
import { CustomForm } from "./CustomForm";
import { OutlinedContainer } from "../../../../../Components/Form/OutlinedContainer";

interface ICustomFieldProps {
    value: ICustomAmountDetailsFormState[];
    onChange(data: ICustomAmountDetailsFormState[]): void;
}

export const CustomField = ({value, onChange}: ICustomFieldProps) => {
    const [values, setValues] = React.useState<ICustomAmountDetailsFormState[]>(value);

    const handleAddNew = () => {
        setValues([...values, {
            label: '',
            value: '',
        }]);
    };

    const handleChange = (index: number) => (data: ICustomAmountDetailsFormState) => {
        const newArray = [...values];
        newArray[index] = data;
        setValues(values);
        onChange(newArray);
    }

    const handleDelete = (index: number) => () => {
        setValues(values.filter((_, i) => i !== index));
    };

    React.useEffect(() => {
        onChange(values);
    }, [values]);

    return (
        <OutlinedContainer label="Custom fees">
            <Box>
                {values.map((item, i) => {
                    return (
                        <CustomForm key={i} value={item} onChange={handleChange(i)} onDelete={handleDelete(i)} />
                    );
                })}
            </Box>

            <Box>
                <AddCustomAction onClick={handleAddNew} />
            </Box>
        </OutlinedContainer>
    );
};
